import { CSSProperties } from 'react';

import { FlexAligner } from '@scaleaq/scaleui';

import { HotKeyLineWithButtonAndDescription } from '@/components/HotKeyLineWithButtonAndDescription.tsx';
import { LayoutPickerHotkeyNames } from '@/hooks/shortcutHooks/hotkeys/types.ts';
import { useLayoutPickerHotKeysDefinitions } from '@/hooks/shortcutHooks/useHotkeyDefinitions/useLayoutPickerHotKeysDefinitions.tsx';
import { responsive } from '@/utils';

const DEFAULT_STYLE: CSSProperties = {
  width: '32rem',
  height: 'fit-content',
};

type LayoutPickerShortcutsProps = {
  style?: CSSProperties;
};

export const LayoutPickerShortcuts = ({ style = DEFAULT_STYLE }: LayoutPickerShortcutsProps) => {
  const layoutPickerHotkeys = useLayoutPickerHotKeysDefinitions();
  return (
    <FlexAligner
      direction='column'
      alignment={'center'}
      style={{ ...style }}
      gap={responsive.spacing['3xlarge']}
    >
      {(Object.keys(layoutPickerHotkeys) as LayoutPickerHotkeyNames[]).map(key => {
        const props = layoutPickerHotkeys[key];
        if (props.disabled) return null;
        return <HotKeyLineWithButtonAndDescription key={props.primary.code} {...props} />;
      })}
    </FlexAligner>
  );
};
